import script from "./PageMetadata.vue?vue&type=script&lang=js"
export * from "./PageMetadata.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__